module.exports = __webpack_public_path__ + "img/201128-4.ced7483a.jpeg";